import React from "react";
import { Tendencia } from "./KpiCard";

// Panel de grafico; si recibe "value" muestra debajo del titulo el monto
// resumen y su tendencia (Valor Total, Rotacion).
export default function ChartPanel(props) {
    return (
        <div className="inv-chart-panel">
            <div className="inv-chart-panel-title">{props.title}</div>
            {props.value === undefined ? null : (
                <div className="inv-chart-panel-resumen">
                    <div className="inv-chart-panel-value">
                        {props.value}
                        {props.valueSuffix ? <span className="inv-chart-panel-suffix"> {props.valueSuffix}</span> : null}
                    </div>
                    <Tendencia direccion={props.tendenciaDireccion} valor={props.tendenciaValor} texto={props.tendenciaTexto} />
                </div>
            )}
            {props.children}
        </div>
    );
}
